
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/stores",
      function () {
        return require("private-next-pages/admin/stores/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/stores"])
      });
    }
  